import React, { createElement, useEffect, useState } from "react";

import Container from "@material-ui/core/Container";
import AdminDashboard from "./AdminHomeDashboard";
import ManagerDashboard from "./ManagerHomeDashboard";
import { useDispatch, useSelector } from "react-redux";
import { isBlank, notBlank } from "../util/ext";
import { logOut } from "../auth/authActions";
import { find, ifElse, pipe, prop, union } from "ramda";
import { hasRole } from "../auth/authUtils";
import Unauthorized from "../auth/Unauthorized";

const dashboards = [
  {
    role: "ROLE_ADMIN",
    dashboard: AdminDashboard,
  },
  {
    role: "ROLE_CONTENT_MANAGER",
    dashboard: ManagerDashboard,
  },
  {
    role: "ROLE_CREATOR_MANAGER",
    dashboard: ManagerDashboard,
  },
];

const UnauthorizedAccess = () => {
  return (
    <Unauthorized message="You do not have the proper access rights to the Creator Application" />
  );
};

const DashboardView = () => {
  // const classes = useStyles();
  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const [principal, setPrincipal] = useState({});

  useEffect(() => {
    if (isBlank(auth)) {
      reduxDispatch(logOut());
    } else {
      const allRoles = union(
        auth.user.roles,
        notBlank(auth.currentOrganization)
          ? auth.currentOrganization.roles
          : [],
      );
      setPrincipal({ roles: allRoles });
    }
  }, [auth, auth.user, reduxDispatch]);

  return (
    <Container id="dashboard-view" disableGutters>
      {pipe(
        find(dashboard => hasRole(principal, dashboard.role)),
        ifElse(notBlank, prop("dashboard"), () => UnauthorizedAccess),
        ele => createElement(ele),
      )(dashboards)}
    </Container>
  );
};

export default DashboardView;
